import cn from 'classnames'
import React from 'react'

import { ComponentType } from '../../lib/types'
import NavigationIcon from '../NavigationIcon'
import styles from './NavigationGroup.module.scss'

import Collapse from '~lib/ui-kit/Collapse'
import Arrow from '~shared/ui/Arrow'
import { PreferLinkType } from '~types/utils'

export interface BaseNavigationGroupProps {
  name: string
  icon: React.ReactNode
  children: React.ReactNode
  selected?: boolean
  opened?: boolean
  component?: ComponentType
}

type NavigationGroupProps = BaseNavigationGroupProps & React.AnchorHTMLAttributes<HTMLAnchorElement>

function NavigationGroup<T extends unknown>({
  component: Component = 'a',
  name,
  icon,
  selected,
  opened,
  children,
  className,
  ...props
}: PreferLinkType<BaseNavigationGroupProps, NavigationGroupProps, T>) {
  return (
    <div className={cn(styles.root, className)}>
      <Component className={cn(styles.toggle, selected && styles.selected)} {...props}>
        <NavigationIcon className={styles.icon}>{icon}</NavigationIcon>
        <span className={styles.name}>{name}</span>
        <Arrow direction={opened ? 'bottom' : 'right'} className={styles.arrow} />
      </Component>

      <Collapse unmount opened={opened} innerClassName={styles.list}>
        {children}
      </Collapse>
    </div>
  )
}

export default NavigationGroup
